import { ErrorBase } from './ErrorBase'

export class ApplicationError extends ErrorBase<string> {
  constructor(message: string) {
    super('application-error', message)
  }
}
